import FirstAccess from "@/pages/first-access/index.vue";
import FirstAccessTerms from "@/pages/first-access/terms.vue";
import FirstAccessBond from "@/pages/first-access/bond.vue";
import BiometryRegister from "@/pages/first-access//biometry-register.vue";
import BiometryAuth from "@/pages/first-access/biometry-auth.vue";
import FirstAccessMailCheck from "@/pages/first-access/mail-check.vue";
import FirstAccessMailForm from "@/pages/first-access/mail-form.vue";
import FirstAccessCodeCheck from "@/pages/first-access/code-check.vue";
import FirstAccessPasswordForm from "@/pages/first-access/password-form.vue";
import FirstAccessSuccess from "@/pages/first-access/success.vue";

const routes: Route[] = [
  {
    path: "/first-access",
    component: FirstAccess,
    meta: {
      allowAnonymous: true
    },
    children: [
      {
        path: "terms",
        name: "first-access.terms",
        component: FirstAccessTerms,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "bond",
        name: "first-access.bond",
        component: FirstAccessBond,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "biometry-register",
        name: "first-access.biometry-register",
        component: BiometryRegister,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "biometry-auth",
        name: "first-access.biometry-auth",
        component: BiometryAuth,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "mailcheck",
        name: "first-access.mailcheck",
        component: FirstAccessMailCheck,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "mailform",
        name: "first-access.mailform",
        component: FirstAccessMailForm,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "code",
        name: "first-access.code",
        component: FirstAccessCodeCheck,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "password",
        name: "first-access.password",
        component: FirstAccessPasswordForm,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "success",
        name: "first-access.success",
        component: FirstAccessSuccess,
        meta: {
          allowAnonymous: true,
          backTo: "/login"
        }
      }
    ]
  }
];

export default routes;
